/* eslint-disable */
import React from 'react';
import Modal from '../../components/modal/Modal';
import ClientIdQrCard from './ClientIdQrCard';
import styles from './ClientIdQrModal.module.css';

export default function ClientIdQrModal({ modalOpen, setModalOpen, clientId }) {
  return (
    <div className={styles.root}>
      <Modal modalOpen={modalOpen} setModalOpen={setModalOpen}>
        {modalOpen ? (
          <div className={styles.panel}>
            <ClientIdQrCard clientId={clientId} inModal />
          </div>
        ) : null}
      </Modal>
    </div>
  );
}
